export default {"src":"/_next/static/media/btcp.ab74a145.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};